import React from "react";
import PropTypes from "prop-types";
import { GelDragDropContext } from "../GelDragDrop.utils";
import { GEL_TYPE } from "../GelDragDrop.constants";
import { GelBand } from "../GelBand";

export function GelPath(props) {
  const { state, onDragOver, getGelValue, onStripDrop, isMultiGelHolder } =
    React.useContext(GelDragDropContext);

  const TYPE = "GEL_PATH";

  const style = {
    height: `${state.gelPathHeight}px`,
    padding: `${state.gelPathPadding}px 0px`,
  };

  const isDraggableBand = (gel) => gel.gelType === GEL_TYPE.DRAGGABLE;

  const setInnerText = (gel) => {
    if (gel.gelType === GEL_TYPE.LABEL) return `${gel.value} bp`;
    if (isMultiGelHolder && isDraggableBand(gel)) return `${gel.gelId + 1}`;
    return null;
  };

  const renderGelBand = (gelBand) => (
    <GelBand
      key={gelBand.gelId}
      type={TYPE}
      gelId={`${props.cellId}_${gelBand.gelId}`}
      gelType={gelBand.gelType}
      height={gelBand.height}
      opacity={gelBand.opacity}
      value={gelBand.value}
      columnType={props.columnType}
      className={`${props.className}__band`}
      options={gelBand.options}
      selectedOption={gelBand.selectedOption}
      selected={gelBand.selected}
      label={props.label}
      tabIndex={props.tabIndex}
    >
      {setInnerText(gelBand)}
    </GelBand>
  );

  const onDrop = (event) => {
    let value = parseInt(getGelValue(event));
    value = value >= state.rangeBottom ? value : state.rangeBottom;
    value = value >= state.rangeTop ? state.rangeTop : value;
    onStripDrop({ event, cellId: props.cellId, value, label: props.label });
  };

  return (
    <div
      style={style}
      className={props.className}
      onDragOver={onDragOver}
      onDrop={onDrop}
      tabIndex={props.tabIndex}
    >
      {props.cellItems.map(renderGelBand)}
    </div>
  );
}

GelPath.propTypes = {
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * Unique Id for the cell
   */
  cellId: PropTypes.string,
  /**
   * ColumnType mention which typeof column
   */
  columnType: PropTypes.string,
  /**
   * List of GelItems to be renderd heree
   */
  cellItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for Gel
       */
      gelId: PropTypes.number,
      /**
       * Type of Gel-Strip
       */
      gelType: PropTypes.oneOf(Object.keys(GEL_TYPE)),
      /**
       * Height value go Gel
       */
      height: PropTypes.number,
      /**
       * Opacity value of Gel
       */
      opacity: PropTypes.number,
      /**
       * Postion value of Gel
       */
      value: PropTypes.number || null,
      /**
       * Boolean to set if gel band is selected
       */
      selected: PropTypes.bool,
    })
  ),
  /**
   * Tabindex value passed from outside the component for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

GelPath.defaultProps = { tabIndex: 0 };
